module.exports = __webpack_public_path__ + "img/0x56747ed2fca81b25fae112c7a9d4465e947aac56.f9c326a4.png";